// The backend onboarding contract: the values accepted by completeOnboarding.
// The wizard maps its build choice onto `use_case`.
//
// BusinessType survives the removal of the question that used to collect it
// (2026-08): the wizard no longer asks it and passes '' for it, but the enum
// is still the type on buildOnboardingPayload's parameter and on the payload the
// marketing zap reads, so it stays part of the CONTRACT even with no UI behind
// it. What went with the question is everything that only rendered it —
// BUSINESS_TYPE_OPTIONS, OnboardingOption, step-business.tsx, OptionCard.
export enum BusinessType {
  DIRECT_BRAND = 'direct_brand',
  RESELLER_PARTNER = 'reseller_partner',
  HOBBY = 'hobby',
}

export enum BuildGoal {
  VOICE_AI_AGENTS = 'voice_ai_agents',
  SIP_TRUNKING = 'sip_trunking',
  AUDIO_STREAMING = 'audio_streaming',
  VOICE_API = 'voice_api',
  MESSAGING = 'messaging',
}

// The POST /orgs/onboarding payload. Every field is optional server-side: the
// endpoint exists to flip `onboarding_completed`, and the answers ride along as
// metadata for the marketing zap (nothing is persisted). `business_type` is now
// always omitted — the wizard passes '', and the payload builder drops an empty
// string rather than sending it (core rejects '').
export interface OnboardingFormData {
  business_type?: string
  use_case?: string
  // Guided wizard answers: the raw build choice, and which agent stack the user
  // is connecting (plus free text for "Custom stack" / "Not for voice agents").
  build?: string
  framework?: string
  framework_detail?: string
  // The no-code path's answer to "What do you need the agent to handle?" —
  // its own key (core#1367), not overloaded onto framework_detail.
  agent_description?: string
  // Step 2, "How did you hear about Plivo?". The detail only accompanies 'other'.
  acquisition_source?: string
  acquisition_source_detail?: string
}
